import {Table} from "antd";
import styled from "styled-components";

/**
 * Mobil uyumlu tablo. 768px altında thead gizlenir, satırlar kart gibi gösterilir.
 * Her hücrede etiket için columns'da onCell kullanın:
 *   onCell: () => ({ "data-label": "Sütun Başlığı" })
 * veya
 *   onCell: (record) => ({ "data-label": "Sütun Başlığı" })
 */
export const ResponsiveDataTableStyled = styled(Table)`
    width: 100%;
    max-width: 100%;
    overflow-x: scroll;

    .ant-table-thead > tr > th {
        font-size: 14px;
        font-weight: 600;
    }

    .ant-table-tbody > tr > td {
        font-size: 13px;
    }

    @media screen and (max-width: 768px) {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;

        .ant-table-wrapper,
        .ant-spin-nested-loading,
        .ant-spin-container,
        .ant-table,
        .ant-table-container,
        .ant-table-content {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
        }

        .ant-table {
            overflow-x: visible;
        }

        .ant-table table {
            min-width: 0 !important;
            width: 100% !important;
            max-width: 100% !important;
            table-layout: auto;
        }

        .ant-table-thead > tr > th,
        .ant-table table th {
            display: none !important;
        }

        .ant-table table thead,
        .ant-table table tbody {
            width: 100% !important;
        }

        colgroup {
            display: none;
        }

        .ant-table table td {
            display: grid !important;
            grid-template-columns: minmax(0, 42%) minmax(0, 1fr);
            column-gap: 14px;
            row-gap: 6px;
            align-items: start;
            justify-items: stretch;
            padding: 14px 16px !important;
            border-bottom: 1px solid #f0f0f0;
            font-size: 14px;
            min-height: 48px;
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box;
            min-width: 0;
            overflow: visible;
        }

        .ant-table table td::before {
            content: attr(data-label);
            font-weight: 600;
            color: #333;
            text-align: left;
            grid-column: 1;
            justify-self: start;
            font-size: 14px;
            min-width: 0;
            max-width: 100%;
            display: block;
            line-height: 1.5;
            word-break: break-word;
            overflow-wrap: break-word;
        }

        .ant-table table td[data-label=""]::before,
        .ant-table table td:not([data-label])::before {
            display: none;
        }

        .ant-table table td:not([data-label]) {
            grid-template-columns: minmax(0, 1fr);
        }

        .ant-table table td:not([data-label]) > * {
            grid-column: 1;
            justify-self: stretch;
            text-align: ${({$contentAlign}) => ($contentAlign === "right" ? "right" : "left")};
        }

        .ant-table table td > * {
            grid-column: 2;
            justify-self: ${({$contentAlign}) => ($contentAlign === "left" ? "start" : "end")};
            text-align: ${({$contentAlign}) => ($contentAlign === "left" ? "left" : "right")};
            min-width: 0;
            max-width: 100%;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-word;
            white-space: normal;
            line-height: 1.5;
            overflow: visible;
        }

        .ant-table table tbody tr {
            display: block;
            margin-bottom: 20px;
            background: white;
            border-radius: 12px;
            border: 1px solid #e8e8e8;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td {
            border-bottom: 1px solid #f5f5f5;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        .ant-table table tbody tr td:first-child {
            padding-top: 16px !important;
            border-top-left-radius: 12px;
            border-top-right-radius: 12px;
        }

        .ant-table table tbody tr td:last-child {
            padding-bottom: 16px !important;
            border-bottom: none;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        .ant-table-tbody > tr:hover > td {
            background: #fafafa;
        }
    }

    @media screen and (max-width: 480px) {
        .ant-table table td {
            font-size: 13px;
            padding: 12px 14px !important;
            grid-template-columns: minmax(0, 46%) minmax(0, 1fr);
            column-gap: 10px;
        }

        .ant-table table td::before {
            font-size: 13px;
        }
    }
`;
